import axios from "axios";
import { nodeType, SourceItem } from "../../pages/ResourcePool/service";
import lodash from "lodash-es";
import { getNoWeekTimeCourseList } from "../course";

export function getMax(targetKey: any) {
    if (targetKey?.includes("FILE")) {
        return 9999;
    }
    switch (targetKey) {
        case "APPEND":
            return 3;
        default:
            return 4;
    }
}

export interface getChapterProp {
    dcCourseChapterEntity: {
        batchNo: string | undefined; //学期no
        courseNo: string; //课程no
        courseSeq: string; //课程seq
        delStatus: string;
    };
    dcCoursewareSourceParam: {
        delStatus: "2" | "";
        sourceFileEntity?: {
            useType: string;
        };
    };
}

// 树形结构
type TreeNode<T, K extends string> = T & {
    [k in K]: TreeNode<T, K>[];
};

// 章节结构
export type ChapterTree = TreeNode<
    {
        key: string;
        chapterName: string;
        id: number;
        chapterCode: string;
        nodeType?: nodeType;
        chapterSort: number;
        dcCourseChapterEntity: {
            batchNo: string | undefined; //学期no
            courseNo: string; //课程no
            courseSeq: string; //课程seq
        };
        dcCoursewareSourceList: SourceItem[];
        level: number;
        parentId: number;
    },
    "children"
>;

//获取章节
export function getChapter(data: getChapterProp) {
    return axios
        .post<SuccessData<ChapterTree>>("/teacher/chapter/getChapter", data)
        .then(res => {
            res.data.data.chapterName = "章节目录";
            return [res.data.data];
        });
}

export interface addChapterProp {
    dcCourseChapterEntity: {
        batchNo: string | undefined; //学期no
        courseNo: string; //课程no
        courseSeq: string; //课程seq
        delStatus: string;
    };
    parentId: number; //父节点id
    chapterName: string; //名称
}
//新增章节
export function addChapter(data: addChapterProp) {
    return axios
        .post("/teacher/chapter/addChapter", data)
        .then(res => res.data.data);
}

export interface updateChapterProp {
    parentId: number; //父节点id
    id: number; //当前id
    chapterName: string; //名称
}
//修改章节
export function updateChapter(data: updateChapterProp) {
    return axios
        .post("/teacher/chapter/updateChapter", data)
        .then(res => res.data.data);
}

export interface moveSourceProp {
    id: string; //课件id
    chapterId: number; //目标章节id
}
//移动课件
export function updateCoursewareSource(data: moveSourceProp) {
    return axios
        .post("/teacher/coursewareSource/updateCoursewareSource", data)
        .then(res => res.data.data);
}

export interface moveChapterProp {
    id: number; //课件id
    parentId: number; //parentId
}
//移动章节
export function moveChapter(data: moveChapterProp) {
    return axios
        .post("/teacher/chapter/moveChapter", data)
        .then(res => res.data.data);
}

export interface deleteProps {
    batchNo: string | undefined;
    courseNo: string;
    courseSeq: string;
    chapterId: string;
    coursewareId: string;
}
//删除节点或课件
export function deleteChapterAndCourseware(data: deleteProps) {
    return axios
        .post("/teacher/chapter/deleteChapterAndCourseware", data)
        .then(res => res.data.data);
}

export interface tempProps {
    id?: number; //章节id:type为0时该属性不能为空
}
export interface tempDataProps {
    id: number;
    templateName: string;
    sourceChapterTemplateTree: {
        children: ChapterTree[];
        id: number;
        chapterName: string;
        chapterCode: string;
        chapterSort: number;
    };
}
//获取章节模版
export function getChapterTemplateList(data: tempProps) {
    return axios
        .post<SuccessData<tempDataProps[]>>(
            "/teacher/chapter/getChapterTemplateList",
            data
        )
        .then(res => res.data.data);
}

export interface postTempProps {
    id: number; //章节模板id
    batchNo: string; //学期no
    courseNo: string; //课程
    courseSeq: string; //课程
    chapterCount: number; //章节数量
    nodeCount: number; //节点数量
}
//引用章节
export function quoteChapterTemplate(data: postTempProps) {
    return axios
        .post("/teacher/chapter/quoteChapterTemplate", data)
        .then(res => res.data.data);
}

export interface findDataProps {
    id: number;
    courseno: string;
    courseseq: string;
    coursename: string;
    customerCode: string;
    batchNo: string;
}
//获取老师的课程
export function findCourse(params: { onlyHasChapter: boolean }) {
    return axios
        .get<SuccessData<findDataProps[]>>("/teacher/chapter/findCourse", {
            params
        })
        .then(res =>
            res.data.data.map((item, index) => {
                return {
                    ...item,
                    key: index.toString()
                };
            })
        );
}

export interface CopyChapterTreeProps {
    oldBatchNo: string | undefined;
    oldCourseNo: string;
    oldCourseSeq: string;
    newBatchNo: string;
    newCourseNo: string;
    newCourseSeq: string;
}
//应用章节
export function copyChapterTree(data: CopyChapterTreeProps) {
    return axios
        .post("/teacher/chapter/copyChapterTree", data)
        .then(res => res.data.data);
}

export interface copyProps {
    //复制的
    dcCourseChapterEntity: {
        batchNo: string | undefined; //学期no
        courseNo: string; //课程no
        courseSeq: string; //课程seq
    };
    //黏贴的
    content: {
        batchNo: string | undefined; //学期no
        courseNo: string; //课程no
        courseSeq: string; //课程seq
    };
}
//复制章节
export function copyChapter(data: copyProps) {
    return axios
        .post("/teacher/chapter/copyChapter", data)
        .then(res => res.data.data);
}

//移动章节 拖拽
export interface MoveChapterProps {
    id: number;
    parentId: number;
    treeSort: number;
    Type: nodeType;
}
export function moveChapterOrCourseware(data: MoveChapterProps) {
    return axios
        .post("/teacher/chapter/moveChapterOrCourseware", data)
        .then(res => res.data.data);
}

//移动章节 拖拽
export interface GetApplyProps {
    keywords: string;
    batchNo: string;
}
export function getApplyCourse(data: GetApplyProps) {
    return getNoWeekTimeCourseList(data.batchNo).then(res => {
        return res.filter(item => {
            if (item.courseNo.includes(data.keywords)) {
                return true;
            }
            if (item.courseSeq.includes(data.keywords)) {
                return true;
            }
            if (item.courseName.includes(data.keywords)) {
                return true;
            }
            return false;
        });
    });
}

//获取树形结构最深层级
export function getMaxFloor(treeData: ChapterTree[]) {
    let max = 0;
    function each(data: any[] = [], floor: number) {
        data.forEach(e => {
            e.floor = floor;
            if (floor > max) {
                max = floor;
            }
            if (e.children.length > 0) {
                each(e.children, floor + 1);
            }
        });
    }
    each(treeData, 1);
    return max;
}
export function getTreeNodeById(data: ChapterTree[], id: number) {
    let Obj: ChapterTree = {
        key: "",
        chapterCode: "",
        chapterName: "",
        chapterSort: 0,
        children: [],
        dcCourseChapterEntity: {
            batchNo: undefined,
            courseNo: "",
            courseSeq: ""
        },
        dcCoursewareSourceList: [],
        id: 0,
        level: -1,
        parentId: 0
    };

    const loop = (data: ChapterTree[], id: number) => {
        for (let i = 0; i < data.length; i++) {
            if (data[i].id == id) {
                Obj = data[i];
            }
            if (data[i].children) {
                loop(data[i].children, id);
            }
        }
    };

    // 所查找到的节点要存储的方法
    loop(data, id);
    return Obj;
}
export function isChapter(v: any): v is ChapterTree {
    if (!v) {
        return false;
    }
    return "chapterName" in v;
}

export function isFile(v: any): v is SourceItem {
    if (!v) {
        return false;
    }
    return "sourceFileEntity" in v;
}

//根据current获取node节点
export function getTreeNodeIndexByCurrent(
    data: ChapterTree[] | null,
    current: SourceItem | ChapterTree
) {
    if (!data) {
        return -1;
    }
    let Father;
    let index = -1;
    if (isFile(current)) {
        Father = getTreeNodeById(data, current.ownerChapter?.id || 0);
        index =
            lodash.findIndex(Father.dcCoursewareSourceList, {
                id: current.id
            }) + Father.children.length;
    }
    if (isChapter(current)) {
        Father = getTreeNodeById(data, current.parentId);
        index = lodash.findIndex(Father.children, {
            id: current.id
        });
    }
    return index;
}

interface DragProps {
    targetNode: ChapterTree | SourceItem;
    formNode: ChapterTree | SourceItem;
    treeData: ChapterTree[];
    dropPosition: number;
}
export function getTreeDragProps({
    targetNode,
    treeData,
    dropPosition,
    formNode
}: DragProps) {
    let badId = 0,
        formBadId = 0;
    if (isChapter(targetNode)) {
        badId = targetNode.parentId;
    }
    if (isFile(targetNode)) {
        badId = targetNode.ownerChapter?.id || 0;
    }
    if (isChapter(formNode)) {
        formBadId = formNode.parentId;
    }
    if (isFile(formNode)) {
        formBadId = formNode.ownerChapter?.id || 0;
    }
    const targetFatherNode = getTreeNodeById(treeData, badId);
    const targetIndex = getTreeNodeIndexByCurrent(treeData, targetNode);
    const formIndex = getTreeNodeIndexByCurrent(treeData, formNode);

    let obj: MoveChapterProps = {
        treeSort: 1,
        id: formNode.id,
        parentId: targetFatherNode.id,
        Type: formNode.nodeType || nodeType.Courseware
    };

    //目标为章节节点
    if (isChapter(targetNode)) {
        //来自于文件
        if (isFile(formNode)) {
            obj.treeSort = 1;
        }
        //来自于章节
        else if (isChapter(formNode)) {
            obj.treeSort = Math.max(dropPosition, targetIndex) + 1;
        }
    }
    //目标为章节
    else if (isFile(targetNode)) {
        //来自于文件
        if (isFile(formNode)) {
            obj.treeSort =
                Math.max(dropPosition, targetIndex) -
                targetFatherNode.children.length +
                1;
        }
        //来自于章节
        else if (isChapter(formNode)) {
            obj.treeSort = targetFatherNode.children.length + 1;
        }
    }

    //判断是否是目标节点同父
    if (badId === formBadId) {
        //判断是否从上移动到下，则sort - 1 因为抽取了一个
        // formIndex < AppendIndex
        if (formIndex < obj.treeSort) {
            obj.treeSort = obj.treeSort - 1;
        }
    }

    return obj;
}
